import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const ADTECH_BANNERS = apiPromiseTypes('adtech-v2', 'post');
export const ADTECH_LEADERBOARD = apiPromiseTypes('adtech-v3', 'post');
export const ADTECH_OFFERS = apiPromiseTypes('adtech-offers', 'post');
export const ADTECH_OFFERS_LEADERBOARDS = apiPromiseTypes('adtech-offers-leaderboards', 'post');
